<template>
  <page>
    <div>
      <v-card>
        <v-flex xs12>
          <message :messages="messages"></message>
        </v-flex>
        <v-card-title>
          <div class="headline">Cargo Port Listing</div>
          <v-spacer></v-spacer>
          <v-text-field append-icon="mdi-magnify" label="Search" single-line hide-details v-model="search"></v-text-field>
        </v-card-title>
        <v-data-table v-bind:headers="headers" v-bind:items="items" v-bind:search="search" :rows-per-page-items="itemsPerPage" v-bind:pagination.sync="pagination" item-key="name" :loading="loading" :no-data-text="noDataText" :filter="customSearch">
          <template slot="headerCell" slot-scope="props">
            <v-tooltip bottom>
              <span slot="activator">
                {{ props.header.text }}
              </span>
              <span>
                {{ props.header.text }}
              </span>
            </v-tooltip>
          </template>
          <template slot="items" slot-scope="props">
            <td>{{ props.item.port }}</td>
            <td class="text-xs-left">{{ props.item.portDesc }}</td>
            <td class="text-xs-right">
              <table-action :rowData="props" :review="checkAccess(['cargoRatingReview'])" @review="doReview" remove @remove="doPromptRemove(props.item)"></table-action>
            </td>
          </template>
        </v-data-table>
      </v-card>
      <div class="pt-2">
        <v-btn color="primary" @click.native="doNew()">
          New Port
          <v-icon right>mdi-plus</v-icon>
        </v-btn>
      </div>
      <v-dialog v-model="portDialog" width="800px" lazy v-if="checkAccess(['cargoRatingReview'])" persistent >
        <port-dialog :portForm="portForm" @close="doClose" :newPort="newPort"></port-dialog>
      </v-dialog>
      <confirm v-model="promptRemove" @ok="doRemove">
        Are you sure that you want to delete the selected Cargo Port? ({{deleteCrgoPort}})
      </confirm>
    </div>
  </page>
</template>

<script>
import { mapGetters } from 'vuex'
import { expandURI } from '@/utils/ajax'
import * as TableConst from '@/mixins/table'
import MessageMixin from '@/mixins/message'
import PortDialog from './PortDialog'

export default {
  data() {
    return {
      headers: [
        { text: 'Cargo Port', align: 'left', value: 'port' },
        { text: 'Cargo Port Description', align: 'left', value: 'portDesc' }
      ],
      portForm: {
        port: undefined,
        portDesc: undefined
      },
      portDialog: undefined,
      newPort: undefined,
      loading: false,
      promptRemove: false,
      selectedCrgoPort: undefined,
      deleteCrgoPort: ''
    }
  },
  computed: {
    ...mapGetters([
      'checkAccess'
    ])
  },
  methods: {
    async fetchData() {
      this.loading = true
      const apiUrl = this.$store.state.cargo.menu.getCrgoPorts
      if (apiUrl) {
        try {
          const result = await this.$http.get(apiUrl)
          const { data } = result.data
          if (data) {
            this.items = []
            data.map((CrgoPort) => {
              const convertCrgoPort = {
                port: CrgoPort.port,
                portDesc: CrgoPort.portDesc
              }
              this.items.push(convertCrgoPort)
            })
            this.loading = false
          }
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.fullMessage(data)
          }
          this.loading = false
        }
      }
    },
    async doReview(Port) {
      const apiURI = this.$store.state.cargo.menu.getCrgoPort
      const expand = {
        port: Port.item.port
      }
      if (apiURI) {
        const result = await this.$http.get(expandURI(apiURI, expand))
        const { data } = result.data
        if (result.data) {
          this.portForm.port = data.port.port
          this.portForm.portDesc = data.port.portDesc
        }
        this.portDialog = true
      }
    },
    doClose() {
      this.portDialog = false
      this.newPort = false
      this.$validator.reset()
      this.fetchData()
    },
    doNew() {
      this.$validator.reset()
      this.portDialog = true
      this.newPort = true
    },
    doPromptRemove(data) {
      if (data) {
        this.promptRemove = true
        this.selectedCrgoPort = data
        this.deleteCrgoPort = data.port + ' - ' + data.portDesc
      }
    },
    async doRemove() {
      const apiURI = this.$store.state.cargo.menu.deletePort
      if (apiURI) {
        this.loading = true
        const expand = {
          port: this.selectedCrgoPort.port
        }
        try {
          const result = await this.$http.delete(expandURI(apiURI, expand))
          this.notify(result.data)
          // Reinit
          this.fetchData()
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.message(data)
          }
          this.loading = false
        }
      } else {
        this.errorMessage('Invalid API URL')
      }
    }
  },
  mounted() {
    // Fetch Users Data
    this.fetchData()
  },
  created() {
    if (this.checkAccess(['cargoRatingReview'])) {
      this.headers.push(TableConst.tableActionHeader)
    }
  },
  components: {
    PortDialog: PortDialog
  },
  mixins: [
    TableConst.default,
    MessageMixin
  ]
}
</script>

<style>

</style>
